import Breadcrumb, { BreadcrumbObject } from "ui/files/core/Breadcrumb";

// /----------------------------------
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { PostReportObj, postsReports } from "assets/data/posts";
import { Link } from "react-router-dom";

const PostsReports = () => {
    const breadcrumb: BreadcrumbObject[] = [
        {
            path: "/",
            text: "Main"
        }
    ];

    // -------------------------- posts report table

    const getReport = (id: string | number): PostReportObj => {
        const report = postsReports.filter((i) => i.id === id)[0];
        return report;
    };

    const columns: GridColDef[] = [
        {
            field: "id",
            headerName: "Name",
            flex: 2,
            minWidth: 250,
            renderCell: (params) => {
                const report = getReport(params.value);
                return (
                    <Link
                        to={`/report-posts/${report.link}`}
                        className="flex flex-col justify-start items-start w-full dark:text-white report-post-title p-2 hover:text-momeento-50"
                    >
                        <span
                            className="font-semibold"
                            style={{ height: "25px", lineHeight: "25px" }}
                        >
                            {report.title}
                        </span>
                        <span style={{ height: "25px", lineHeight: "25px" }}>
                            {report.desc}
                        </span>
                    </Link>
                );
            }
        },
        { field: "count", headerName: "Count", flex: 1, minWidth: 75 }
    ];

    return (
        <section className="w-full h-full flex flex-col relative">
            <div className="w-full h-full flex relative overflow-auto">
                <div className="w-full flex flex-col">
                    <div className="w-full text-center">
                        <Breadcrumb
                            breadcrumb={breadcrumb}
                            currentPath="Posts Reports"
                        />
                        <h1 className="font-medium text-lg dark:text-white py-8">
                            Posts Reports
                        </h1>
                    </div>
                    <div className="w-full items-center flex flex-col gap-10 px-10 pb-10 large-row-data-grid">
                        <DataGrid
                            rows={postsReports}
                            columns={columns}
                            pageSizeOptions={[6]}
                            rowHeight={60}
                            getRowId={(row: PostReportObj) => row.id}
                            className="w-full"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PostsReports;
